import swal from "sweetalert";
import * as global from './globals';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const getDMThemes = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmthemes/get_dmthemes?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Theme",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getDMItems = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmitems/get_items_to_digital_menu?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Items",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getDMCategories = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmcategories/get_dmcategories?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Categories",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getDMSubCategories = (dmcat_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmsubcategories/get_dmsubcategories?dmcat_id=${dmcat_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Sub Categories",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getDMMainAndSubCategories = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmcategories/get_dmcategories_with_sub?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Categories",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getDMSubAndMainCategories = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}dmsubcategories/get_dmsubcategories_with_sub?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Digital Menu Categories",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const getCurrencies = (cmp_id) => {
    return new Promise((resolve) => {
        fetch(`${global.baseUrl}currencies/get_main_currencies?cmp_id=${cmp_id}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.error) {
                    resolve(response);
                } else {
                    swal(
                        "error fetching Currency",
                        response.error.originalError.info.message,
                        "error"
                    );
                }
            })
            .catch((err) => console.log(err));
    });
}

export const findRate = (curr, curr1) => {
    const url = `${global.baseUrl}rates/sel_rate`;
    return new Promise((resolve, reject) => {
        try {
            fetch(`${url}?curr=${curr}&curr1=${curr1}`)
                .then((response) => response.json())
                .then((result) => resolve(result))
                .catch((error) => reject(error));
        } catch (error) {
            reject(error);
        }
    });
}

export const toastMessage = (msg, type) => {
    if (type === "success") {
        toast.success(msg, {
            position: "top-right",
            style: { fontSize: "20px" },
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
    }
    else if (type === "error") {
        toast.error(msg, {
            position: "top-right",
            style: { fontSize: "20px" },
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
    }
    else if (type === "warning") {
        toast.warning(msg, {
            position: "top-right",
            style: { fontSize: "20px" },
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
    }
    else if (type === "info") {
        toast.info(msg, {
            position: "top-right",
            style: { fontSize: "20px" },
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
    }
}
